import React from 'react';

// Helpers
import {
  getLocalizedTextForUnitState,
  getColorForUnitState
} from 'helpers/units/VmUnitHelper';

// Styling
import styled from 'styled-components';

const Badge = styled.div`
  // Fixed size because it should always have the same size no matter what the unit state is
  width: 6rem;
  height: 2rem;

  font-size: 0.95rem;
  font-family: 'proxima-nova' sans-serif;
  color: ${(props) => props.theme.showcaseWhite};

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 2px;

  background-color: ${(props) =>
    getColorForUnitState(props.theme, props.unitState)};
`;

const UnitStateBadge = ({ unitState, className, unitFlow }) => {
  const isRentalFlow = unitFlow === 'rental';
  return (
    <Badge unitState={unitState} className={className}>
      {getLocalizedTextForUnitState(unitState, isRentalFlow).toUpperCase()}
    </Badge>
  );
};

export default UnitStateBadge;
